<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="datoFecha?.desde" 
            [DateEnd]="datoFecha?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="datosFechasHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="datoFecha?.id">
</iboxtools>

<app-datos-fechas-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                             [datosFechas]="datosFechas" 
                                                             [permisoEdicion]="permisoEdicion"
                                                             (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-datos-fechas-list>

<app-datos-fechas-detalle #ChildDatoFechaDetalle [datoFecha]="datoFecha" *ngIf="verDetalle" 
                            [enabledForm]="habilitarFormDetalle" 
                            [MensajeError]="MensajeError" 
                            [desdeAnterior]="desdeAnterior" 
                            [ingreso]="ingreso"
                            [anteriorRetroactividad]="anteriorRetroactividad" 
                            [grupoLiq]="gruposLiquidaciones"
                            [datosFechasInvalida]="datosFechasInvalida">
</app-datos-fechas-detalle>

